async function fetchCollectionProduct(productsLink) {
    var products = [];
    return fetch(productsLink).then(resp => resp.json()).then(data => {
        var tmp_products = data['products'].splice(0, 8);
        for (var i = 0; i < tmp_products.length; i++) {
            products.push({
                id: tmp_products[i].id,
                title: tmp_products[i].title,
                handle: tmp_products[i].handle,
                image: tmp_products[i].images[0].src,
            })
        }

        return products;
    });
};

function toggleElement(wrapper, selector, isShow, activeDisplay = 'block') {
    var _wrapper = wrapper ? wrapper : document;
    var elem = _wrapper.querySelector(selector);
    if (isShow) {
        elem.style.display = activeDisplay;
    } else {
        elem.style.display = 'none';
    }
}

function removeActiveClass(wrapper) {
    wrapper.querySelectorAll('.mega-menu-2__sublink a').forEach(function (element) {
        element.classList.remove("is-hover");
    });
    wrapper.querySelectorAll('.mega-menu-2__content__main').forEach(function (element) {
        element.style.display = 'none';
    });
}

window.onload = () => {
    // document.querySelectorAll('.mega-menu-rugs').forEach(function (elemMenu) {
    //     document.querySelectorAll('.mega-menu-rugs__sublink a').forEach(function (element) {
    //         element.addEventListener('mouseover', async function () {

    //             removeActiveClass(elemMenu);
    //             element.classList.add("is-hover");
    //             var collectionLink = element.getAttribute('href');
    //             if (!collectionLink) return;

    //             toggleElement(elemMenu, ".mega-menu-block__content", false);
    //             toggleElement(elemMenu, ".mega-menu-rugs__content", false);
    //             toggleElement(elemMenu, ".mega-menu-loading", true, "flex");

    //             var products = [];
    //             try {
    //                 var megaMenuJsonTag = elemMenu.querySelector(".megaMenuEmbJson");
    //                 var megaMenuContentTag = elemMenu.querySelector(".mega-menu-rugs__content__main");

    //                 var megaMenuJson = megaMenuJsonTag.textContent;
    //                 megaMenuJson = megaMenuJson.trim() ? JSON.parse(megaMenuJson) : {};

    //                 if (megaMenuJson[collectionLink]) {
    //                     products = megaMenuJson[collectionLink];
    //                 } else {
    //                     var productsLink = collectionLink + "/products.json";

    //                     products = await fetchCollectionProduct(productsLink);

    //                     megaMenuJson[collectionLink] = products;
    //                     megaMenuJsonTag.innerHTML = JSON.stringify(megaMenuJson);
    //                 }

    //                 if (products.length == 0) return;

    //                 megaMenuContentTag.innerHTML = '';
    //                 // Creating Image Content Block
    //                 for (var j = 0; j < products.length; j++) {
    //                     var elemWrapper = document.createElement("a");
    //                     elemWrapper.className = "content-tile";
    //                     elemWrapper.href = "/products/" + products[j].handle;

    //                     var elemImg = document.createElement("img");
    //                     elemImg.src = products[j].image;
    //                     elemImg.setAttribute("loading", "lazy");
    //                     elemWrapper.appendChild(elemImg);

    //                     var elemTitle = document.createElement("p");
    //                     elemTitle.innerHTML = products[j].title;
    //                     elemWrapper.appendChild(elemTitle);

    //                     megaMenuContentTag.appendChild(elemWrapper);
    //                 }

    //                 var shopAllButton = elemMenu.querySelector(".mega-menu-rugs__content a.button-shop-all");
    //                 shopAllButton.href = collectionLink;

    //                 toggleElement(elemMenu, ".mega-menu-rugs__content", true);
    //                 toggleElement(elemMenu, ".mega-menu-loading", false);

    //             } catch (error) {
    //                 console.log(error);
    //             }
    //         });

    //         element.addEventListener('mouseleave', function () {
    //             // element.classList.remove("is-hover");
    //             // var megaMenuContentTag = document.querySelector(".mega-menu-rugs__content__main");
    //             // megaMenuContentTag.innerHTML = '';
    //         });
    //     });
    // });

    // var imagesAndPromoMenus = document.querySelectorAll(".mega-menu-images_promo");
    // if (imagesAndPromoMenus) {
    //     imagesAndPromoMenus.forEach(async function (element) {
    //         var megaMenuContentTag = element.querySelector(".mega-menu-images__content__main");

    //         toggleElement(element, ".mega-menu-images__content", false);
    //         toggleElement(element, ".mega-menu-loading", true, "flex");

    //         var btnShopLink = element.querySelector("a.button-shop-all");
    //         var shopLink = btnShopLink.getAttribute('href');
    //         var productsLink = shopLink + "/products.json";
    //         var products = await fetchCollectionProduct(productsLink);

    //         if (products) {
    //             megaMenuContentTag.innerHTML = '';
    //             // Creating Image Content Block
    //             for (var j = 0; j < products.length; j++) {
    //                 var elemWrapper = document.createElement("a");
    //                 elemWrapper.className = "content-tile";
    //                 elemWrapper.href = "/products/" + products[j].handle;

    //                 var elemImg = document.createElement("img");
    //                 elemImg.src = products[j].image;
    //                 elemImg.setAttribute("loading", "lazy");
    //                 elemWrapper.appendChild(elemImg);

    //                 var elemTitle = document.createElement("p");
    //                 elemTitle.innerHTML = products[j].title;
    //                 elemWrapper.appendChild(elemTitle);

    //                 megaMenuContentTag.appendChild(elemWrapper);
    //             }
    //         }

    //         toggleElement(element, ".mega-menu-images__content", true);
    //         toggleElement(element, ".mega-menu-loading", false);
    //     })
    // }

    document.querySelectorAll('.mega-menu-2').forEach(function (elemMenu) {
        document.querySelectorAll('.mega-menu-2__sublink a').forEach(function (element) {
            element.addEventListener('mouseover', async function () {
                removeActiveClass(elemMenu);
                element.classList.add("is-hover");
                var tabId = element.getAttribute("data-id");
                toggleElement(elemMenu, ".mega-menu-2__content__main[data-id=" + tabId + "]", true);
            });

            element.addEventListener('mouseleave', function () {
                // element.classList.remove("is-hover");
                // var megaMenuContentTag = document.querySelector(".mega-menu-rugs__content__main");
                // megaMenuContentTag.innerHTML = '';
            });
        });
    });
};
